
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.938.036h-5.625C10.588.036 10 .624 10 1.348v1.875c0 .724.589 1.313 1.313 1.313h5.624c.724 0 1.313-.59 1.313-1.313V1.348c0-.724-.589-1.312-1.313-1.312zM16.938 7.036h-5.625c-.724 0-1.313.588-1.313 1.312v1.875c0 .724.589 1.313 1.313 1.313h5.624c.724 0 1.313-.59 1.313-1.313V8.348c0-.724-.589-1.312-1.313-1.312zM16.938 13.036h-5.625c-.724 0-1.313.588-1.313 1.312v1.875c0 .724.589 1.313 1.313 1.313h5.624c.724 0 1.313-.59 1.313-1.313v-1.875c0-.724-.589-1.312-1.313-1.312zM1.313 18.036h5.625c.723 0 1.312-.59 1.312-1.313V1.348C8.25.624 7.661.036 6.937.036H1.313C.59.036 0 .624 0 1.348v15.375c0 .724.589 1.313 1.313 1.313z"}})])
          )
        }
      }
    